
import menuItem from "@/components/MenuItemCom.vue";
import Vue from "vue";
import { MenuDetail } from "@/assets/js/Model/ResponseModel";
import { StoreTypes } from "@/assets/js/Types";
interface dataModel {
  menus: MenuDetail;
  state: any;
}
export default Vue.extend({
  components: { menuItem },
  data() {
    const ret: dataModel = {
      menus: {
        menuName: "",
        menuPic: "",
        order: "",
        parentMenuSid: "",
        path: "",
        showInLine: "",
        sid: "",
        childrens: [],
      },
      state: this.$store.state,
    };
    return ret;
  },
  mounted() {
    this.getMenu();
  },
  watch: {
    "$store.state.freshProject"() {
      this.getMenu();
    },
    $route(to, from) {
      this.getMenu();
      console.log("route change", to.path);
    },
  },
  methods: {
    getMenu() {
      const project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
      if (project) {
        if (project.sid == "2026072708365582733200727557b4844") {
          this.menus.childrens = [];
          project.menu.childrens.forEach((m: any) => {
            if (m.sid != "20220826120111251266004053e38d122") {
              this.menus.childrens?.push(m);
            }
          });
        } else {
          this.menus = project.menu;
          console.log(project.menu);
          this.menus.childrens = project.menu.childrens.filter(
            (item: any) => item.showInLine == 1
          );
        }
      }
    },
    menuClick(menu: MenuDetail) {
      if (this.$route.path.toLowerCase() != menu.path.toLowerCase())
        this.$router.push(menu.path);
    },
  },
});
